(() => {
  const initLanding = (root) => {
    if (!root || root.dataset.nbInitialized === 'true') return;
    root.dataset.nbInitialized = 'true';

    const storefrontMode = root.dataset.storefrontMode;
    const form = root.querySelector('.nb-landing__product-form');
    const variantInput = form?.querySelector('[name="id"]');
    const variantSelect = root.querySelector('[data-nb-variant-select]');
    const price = root.querySelector('[data-nb-price]');
    const buyNow = root.querySelector('[data-nb-buy-now]');
    const soldOut = root.querySelector('[data-nb-sold-out]');
    const prelaunchAction = root.querySelector('[data-nb-primary-action]');
    const sticky = root.querySelector('[data-nb-sticky]');
    const stickyButton = root.querySelector('[data-nb-sticky-add]');
    const stickyPrice = root.querySelector('[data-nb-sticky-price]');
    const emailCta = root.querySelector('[data-nb-email-cta]');
    const emailSection = root.querySelector('[id^="NBEmail-"]');

    const updateVariant = () => {
      if (!variantSelect || !variantInput) return;
      const option = variantSelect.options[variantSelect.selectedIndex];
      const available = option.dataset.available === 'true';

      variantInput.value = option.value;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      if (buyNow) buyNow.hidden = !available;
      if (soldOut) soldOut.hidden = available;
      if (stickyButton) {
        stickyButton.disabled = false;
        stickyButton.querySelector('span').textContent = available ? 'Buy now' : 'Join the list';
      }
      emailCta?.classList.toggle('is-hidden', available);
      if (price) {
        price.innerHTML = option.dataset.price;
        if (option.dataset.comparePrice) {
          const compare = document.createElement('s');
          compare.textContent = option.dataset.comparePrice;
          price.append(' ', compare);
        }
      }
      if (stickyPrice) stickyPrice.textContent = option.dataset.price;
    };

    variantSelect?.addEventListener('change', updateVariant);
    if (stickyButton) {
      stickyButton.disabled = false;
      stickyButton.addEventListener('click', () => {
        const shouldCaptureEmail = storefrontMode === 'prelaunch' || !buyNow || buyNow.hidden;
        if (shouldCaptureEmail) {
          emailSection?.scrollIntoView({ behavior: 'smooth' });
          return;
        }

        const checkoutButton = buyNow.querySelector('.shopify-payment-button__button');
        if (checkoutButton) checkoutButton.click();
        else buyNow.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    const primaryAction = prelaunchAction || buyNow || soldOut;
    if (sticky && primaryAction) {
      sticky.hidden = false;
      const observer = new IntersectionObserver(
        ([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting),
        { threshold: 0.05 }
      );
      observer.observe(primaryAction);
    }
  };

  document.querySelectorAll('[data-nb-landing]').forEach(initLanding);
  document.addEventListener('shopify:section:load', (event) => initLanding(event.target.querySelector('[data-nb-landing]')));
})();
